import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { CREATIVE_REALTIME_REPORT_ID } from './creativeRealtimeReportId';

const emptyColumns = [
    FIELDS.IS_ACTIVE,
    FIELDS.ID,
    FIELDS.THUMBNAIL_URL,
    FIELDS.THUMBNAIL_URL_COMFORTABLE,
    FIELDS.CONTENT,
    FIELDS.TITLE,
    FIELDS.URL,
    FIELDS.STATUS,
    FIELDS.CTA,
    FIELDS.DESCRIPTION,
    FIELDS.ACTIONS_COLUMN,
].map(createFooterMapper(CREATIVE_REALTIME_REPORT_ID));

const creativeRealtimeReportFooterColumnDefinition = [...emptyColumns];

export default creativeRealtimeReportFooterColumnDefinition;
